import React from "react";
import { NoData, UnlimitedTable } from "components";
import { useSelector } from "react-redux";

export default function Details() {
  // Redux
  const order = useSelector(state =>
    state.subsDetail?.qnA.filter(item => item.questionType === "detail")
  );

  return (
    <div>
      {order?.length ? (
        order.map((qna, index) => (
          <UnlimitedTable
            key={index}
            question={qna.questionName}
            answers={qna.answers}
          />
        ))
      ) : (
        <NoData />
      )}
    </div>
  );
}
